<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconiconfont-baoming"></i>
      持证教师
    </div>
    <div class="padding-sm">
      <div class="table-warpper">
        <el-table
            :data="teacherList"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            fit
            style="width: 100%"
        >
          <el-table-column label="序号" type="index" width="100"></el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.admin_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="研学指导师证书编号">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.yx_number }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="教师证编号">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.teach_number }}
              </div>
            </template>
          </el-table-column>
        </el-table>

      </div>
    </div>

  </div>
</template>

<script>
import {getOrgTeacher} from "@/api/projectOffice";

export default {
  name: "teacherList",
  data() {
    return {
      teacherList: [],
    };
  },
  created() {
    this.$emit(
        "setIndex",
        '/projectOffice/organization',
        "当前位置：持证教师",
        true
    );
    this.getList();
  },
  methods: {
    async getList() {
      let _list = await getOrgTeacher(
          this.$route.query.id,
      );
      this.teacherList = _list.data;
    },

  },
  watch:{
  }
}
</script>

<style scoped lang="scss">

</style>